<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GXdY8r/tc-custom/9783968652139.jpg?1717071644169" alt="This image is the cover for the book More English Fairy Tales"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">More English Fairy Tales
      </h1>
      <p class="bookDescription body article font2">
        <p>More English Fairy Tales is a collection of traditional English folk tales compiled by Joseph Jacobs, first published in 1894. The book contains a diverse array of stories, each with its own unique characters, settings, and moral lessons. A favorite of children, parents, and teachers for generations, this heartwarming classic first appeared in 1880. Since then, it has inspired countless young imaginations with its tender tales of the ways in which courage and good cheer can overcome adversity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Jacobs, John Dickson Batten
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b8612e2